export default __webpack_public_path__ + "e30b2d67111b0595d28817f465afcbfe.svg";